import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ManufacturerOPEEnum} from "./ManufacturerOPEEnum";

class O {
}

/**
 * O Inner Class
 */
class I {
  id!: number;
}

export class DelManufacturerCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(ManufacturerOPEEnum.DelManufacturer);
    this.i = new I();
    this.o = new O();
  }
}
